import { whiteColor } from "@config"
import React from "react"
import * as styles from "./pageMostCollections.module.scss"

import frame1Img from "@images/png/11.png"
import frame2Img from "@images/png/12.png"
import frame3Img from "@images/png/13.png"
import createPage from "@src/components/page"
import classnames from "@src/utils/classnames"
import { animated } from "@react-spring/web"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { imageCdnUrl } from "@src/utils/request"

const frameImgs = [frame1Img, frame2Img, frame3Img]

const PageMostCollections = createPage(
  ({ data, offset }) => {
    const { collections } = data
    const anime1Styles = useEnteringTrail(collections.length, offset, {
      type: "mt",
    })
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.7 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div className={styles.framesContainer}>
          <div className={styles.frames}>
            {collections.map((collection, i) => (
              <animated.div
                key={collection.id}
                style={anime1Styles[i]}
                className={classnames(styles.frame, styles[`frame${i + 1}`])}
              >
                <img
                  src={imageCdnUrl(collection.attributes.cover, {
                    w: 450,
                    h: 535,
                  })}
                  alt="专题封面"
                />
                <img src={frameImgs[i]} alt="album" />
              </animated.div>
            ))}
          </div>
        </div>
        <div className={styles.text}>
          <animated.div style={anime2Styles[0]}>
            {callYou(data)}最喜欢的专题
            <br />
            <strong>{collections[0].attributes.title}</strong>
          </animated.div>
          {collections.length > 1 && (
            <animated.div style={anime2Styles[1]}>
              <strong>{collections[1].attributes.title}</strong>
              {collections.length > 2 && (
                <>
                  和<br />
                  <strong>{collections[2].attributes.title}</strong>
                </>
              )}
              <br />
              {callYou(data)}也常看
            </animated.div>
          )}
        </div>
        <animated.div className="bottomText" style={anime3Styles[0]}>
          2021 年最受欢迎的专题：
          <br />
          《想买书，来核市，很合适！》
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pageMostCollectionsData = {
  key: "mostCollections",
  bg: whiteColor,
  Page: PageMostCollections,
  shouldHide: ({ collections }) => {
    return collections.length === 0
  },
}

export default PageMostCollections
